import React from 'react';
import { useSelector } from 'react-redux';
import './index.scss';

const TopBanner = () => {
    const translations = useSelector((store) => store.config.Translations);

    return (
        <div className="benefits-top-banner">
            <h2 className="banner-title">
                {translations['all_benefits_page_title']}
            </h2>
        </div>
    );
};

export default TopBanner;
